// extracted by mini-css-extract-plugin
export var banner = "_c7-0";
export var closeButton = "_c7-2";
export var greenCheckmark = "_c7-3";
export var hereLink = "_c7-4";
export var titleIcon = "_c7-1";